import http from '@/http'

export default {
    data() {
        return {
            loading: true
        }
    },

    methods: {
        load(resources, callback = null) {
            this.loading = true

            axios.all(this.loadUrls(resources))
                .then(responses => {
                    this.saveLoadedData(resources, responses)

                    if (callback) {
                        callback()
                    }

                    this.loading = false
                })
        },

        loadUrls(resources) {
            return _(resources)
                .values()
                .map(url => {
                    return http.get(url)
                })
        },

        saveLoadedData(resources, responses) {
            _(resources)
                .keys()
                .each((variable, index) => {
                    this[variable] = responses[index].data
                })
        }
    }
}
